import type { SitePayload } from "../../api/sites";

export type SiteChoiceInput = {
  mode: "matched" | "separate" | "create";
  siteId?: number;
  siteName?: string;
  ean?: string;
};

/**
 * Shapes the optional `site` block for the addContract payload.
 *
 * Returns null when no site block should be sent: the split second-contract call (any
 * `overrideDirection`), no choice or a stale choice for a different EAN, or a create whose
 * name is empty. Attach (matched mode) is emitted even with an empty name — the backend
 * ignores `name` on attach and legacy/customer-switch sites can be nameless, so gating
 * attach on a non-empty name would silently drop the linkage.
 */
export const buildSitePayload = (
  overrideDirection: "injection" | "offtake" | undefined,
  contractType: "injection" | "offtake" | "combined",
  payloadEan: string,
  siteChoice: SiteChoiceInput | null
): SitePayload | null => {
  if (overrideDirection !== undefined) return null;
  if (!siteChoice || siteChoice.ean !== payloadEan) return null;

  const direction = contractType === "combined" ? "both" : contractType;
  const name = (siteChoice.siteName ?? "").trim();
  const isAttach = siteChoice.mode === "matched" && siteChoice.siteId != null && direction !== "both";

  if (isAttach) {
    return { direction, decision: "attach", site_id: siteChoice.siteId, name };
  }
  if (name) {
    return { direction, decision: "create", name };
  }
  return null;
};
